/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

export function stickyGallery() {

  if (window.innerWidth > 960) {

    ScrollTrigger.create({
      trigger: ".mim",
      endTrigger: '.scrollGallery',
      start: "bottom top",
      end: "bottom 50%",
      pin: '.gather__background',
      pinSpacing: false,
      anticipatePin: 1,
      invalidateOnRefresh: true
      // markers: true
    });

    ScrollTrigger.create({
      trigger: ".mim",
      endTrigger: '.scrollGallery',
      start: "bottom top",
      end: "bottom 50%",
      pin: '.gather--inner',
      pinSpacing: false,
      invalidateOnRefresh: true
      // markers: true
    });

    gsap.to('.gather__title', {
      scrollTrigger: {
        trigger: ".gather__title",
        scrub: 1,
        start: 'top 90%',
        end: 'top 50%',
        // markers: true,
      },
      letterSpacing: '.05em',
      autoRound: false
    });

  }
}
